import React, { useState, useEffect, ReactNode, useRef } from "react";
import "./hover.css";

interface HoverProps {
  children: ReactNode;
  action: Function;
  text: string;
  extraClasses: string;
  timeout?: number;
  additionalClasses?: string;
  animationDuration?: number;
  disable?: boolean;
}

const Hover: React.FC<HoverProps> = ({
  children,
  action,
  text,
  extraClasses = "",
  timeout = 5000,
  additionalClasses = "",
  animationDuration = 500,
  disable,
}) => {
  const [show, setShow] = useState(false);
  const classlist = useRef(additionalClasses);

  useEffect(() => {
    if (!classlist.current && !!additionalClasses) {
      classlist.current = additionalClasses;
    }
  }, [additionalClasses]);

  useEffect(() => {
    if (show) {
      setTimeout(() => {
        setShow(false);
        action(null);
      }, timeout);
    }
    /* eslint-disable react-hooks/exhaustive-deps */
  }, [show]);

  return (
    <div
      className={`${classlist.current}`}
      onMouseEnter={() => {
        if (!disable) {
          action(text);
        }
      }}
      onMouseLeave={() => {
        action(null);
      }}
    >
      {children}
    </div>
  );
};

export default Hover;
